/* eslint-disable react/prop-types */
import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

const StyledTableCell = styled(TableCell)({
  paddingRight: '0',
  paddingLeft: '0',
  width: '60px',
  textAlign: 'center',
});

function TableCellAction(props) {
  const { title, children, onClick, classes, buttonClassName, paddingNone, actionsDisabled, className } =
    props;
  return (
    <StyledTableCell classes={classes} padding={paddingNone ? 'none' : 'normal'} className={className}>
      <Tooltip title={title}>
        <IconButton
          aria-label={title}
          color="primary"
          onClick={onClick}
          className={buttonClassName}
          disabled={actionsDisabled}
          size="large"
        >
          {children}
        </IconButton>
      </Tooltip>
    </StyledTableCell>
  );
}

TableCellAction.defaultProps = {
  children: null,
  paddingNone: true,
  actionsDisabled: false,
};

TableCellAction.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  paddingNone: PropTypes.bool,
  actionsDisabled: PropTypes.bool,
};
export default TableCellAction;
